import { apiRequest } from './client.js';

export interface DashboardData {
  window: { from: string; to: string };
  filters: { sector: string | null; auditor_id: string | null };
  assessments: {
    draft: number;
    in_progress: number;
    completed: number;
    cancelled: number;
    total: number;
  };
  avg_duration_seconds: number | null;
  avg_global_score: number | null;
  avg_per_domain: { template_code: string; domain: string; average: number; samples: number }[];
  /** Total de fotos capturadas en el rango (proxy de "evidencias"). */
  evidences_captured: number;
  /** Count real de findings con status open|in_progress (S13). */
  open_findings: number;
  top_auditors: { auditor_id: string; email: string; completed: number }[];
  top_risk_clients: {
    id: string;
    name: string;
    sector: string | null;
    average_score: number;
    assessments: number;
  }[];
}

export const adminDashboardApi = {
  get: (params: { from?: string; to?: string; sector?: string; auditor_id?: string } = {}) => {
    const qs = new URLSearchParams();
    if (params.from) qs.set('from', params.from);
    if (params.to) qs.set('to', params.to);
    if (params.sector) qs.set('sector', params.sector);
    if (params.auditor_id) qs.set('auditor_id', params.auditor_id);
    const path = `/api/v1/admin/dashboard${qs.toString() ? '?' + qs.toString() : ''}`;
    return apiRequest<DashboardData>(path);
  },
};

export interface TrendBucket {
  start: string;
  per_domain: Record<string, { average: number; samples: number }>;
  total_samples: number;
}

export interface TrendData {
  window: { from: string; to: string };
  bucket: 'day' | 'week' | 'month';
  domains: string[];
  buckets: TrendBucket[];
}

export const adminInsightsApi = {
  trend: (params: { from?: string; to?: string; bucket?: 'day' | 'week' | 'month' } = {}) => {
    const qs = new URLSearchParams();
    if (params.from) qs.set('from', params.from);
    if (params.to) qs.set('to', params.to);
    if (params.bucket) qs.set('bucket', params.bucket);
    const path = `/api/v1/admin/insights/trend${qs.toString() ? '?' + qs.toString() : ''}`;
    return apiRequest<TrendData>(path);
  },
};
